export const fileSignatures = {
  '89504E47': 'image/png',
  '25504446': 'application/pdf'
};
